var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73452 2.59834C2.92781 2.40217 3.21318 2.32732 3.47768 2.404C10.1763 4.34991 16.3971 7.41868 21.923 11.3913C22.1189 11.5322 22.2354 11.7584 22.2355 11.9997C22.2354 12.241 22.119 12.4682 21.923 12.6091C16.3972 16.5817 10.1761 19.6495 3.47768 21.5954C3.21308 21.6721 2.92782 21.5974 2.73452 21.4011C2.5413 21.2047 2.47102 20.9183 2.5519 20.655L5.21401 11.9997L2.5519 3.34541C2.47085 3.08198 2.54124 2.7948 2.73452 2.59834ZM6.5519 11.2497L13.5001 11.2507L13.5763 11.2536C13.9547 11.2919 14.2501 11.6122 14.2501 12.0007C14.2498 12.3888 13.9544 12.7085 13.5763 12.7468L13.5001 12.7497H6.55288L4.40054 19.7468C10.0786 17.9493 15.3866 15.3192 20.1818 11.9997C15.3865 8.68029 10.0787 6.05 4.40054 4.25263L6.5519 11.2497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.d9fb8571a797017cf3fe8637c99b5187.svg";
export { ForwardRef as ReactComponent };